import Grid from '@mui/joy/Grid'
import { AspectRatio } from '@mui/joy'
import Image from 'next/image'
import Section from '../../Section/Section'
import { Text } from '../../Text'

function Item({ title, children }) {
    return (
        <>
            <Text fontWeight={700} color="#0d417d">
                {title}
            </Text>
            <Text whiteSpace="break-spaces" mb={4}>
                {children}
            </Text>
        </>
    )
}

const LABELS = {
    zh: {
        address: '地址',
        phone: '电话',
        support: '客服支持',
        generalInquiries: '常见咨询',
        customerService: '客户服务',
        accounting: '账单问题',
    },
    en: {
        address: 'Address',
        phone: 'Phone',
        support: 'Support',
        generalInquiries: 'General Inquiries',
        customerService: 'Customer Service',
        accounting: 'Accounting',
    },
}

export default function Information({ heroImage, about, locale = 'en' }) {
    return (
        <Section bg="#fff" py={24}>
            <Grid container alignItems="center">
                <Grid sm={12} md={6} container>
                    <Grid xs={6}>
                        <Item title={LABELS[locale].address}>
                            {about?.address}
                        </Item>
                        <Item title={LABELS[locale].phone}>{about?.phone}</Item>
                        <Item title={LABELS[locale].support}>
                            {about?.support}
                        </Item>
                    </Grid>
                    <Grid xs={6}>
                        <Item title={LABELS[locale].generalInquiries}>
                            {about?.generalInquiries}
                        </Item>
                        <Item title={LABELS[locale].customerService}>
                            {about?.customerService}
                        </Item>
                        <Item title={LABELS[locale].accounting}>
                            {about?.accounting}
                        </Item>
                    </Grid>
                </Grid>
                <Grid sm={12} md={6}>
                    <AspectRatio ratio="1 / 1">
                        <Image
                            quality={80}
                            fill
                            src={heroImage?.url}
                            alt={heroImage?.alt}
                            style={{
                                objectFit: 'cover',
                                borderRadius: '0% 45% 0% 0%',
                            }}
                        />
                    </AspectRatio>
                </Grid>
            </Grid>
        </Section>
    )
}
